import { Url } from '@/shared/models/common';

export default class MediaFileContent {
  original: Url | null = null;
  medium: Url | null = null;
  small: Url | null = null;
  extraSmall: Url | null = null;

  static placeholder(url: Url): MediaFileContent {
    const content = new MediaFileContent();
    content.original = url;
    content.medium = url;
    content.small = url;
    content.extraSmall = url;
    return content;
  }
}